import React from 'react';
import { ArrowRight, PawPrint } from 'lucide-react';
import { Badge, Button } from './ui';
type HeroProps = {
  onPurchaseRequest?: () => void;
};
export function Hero({
  onPurchaseRequest
}: HeroProps) {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('planes');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
      return;
    }
    onPurchaseRequest?.();
  };
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-14">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-15"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-16">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-17">
          <PawPrint className="w-6 h-6 text-brand-400" aria-hidden="true" data-id="element-18" />
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-19">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-[52px] font-black text-white mb-4 tracking-tight text-[23px]" data-id="element-20">
          TODO LO QUE NECESITÁS PARA EDUCAR A TU CACHORRO
          <br data-id="element-21" />
          <span className="text-brand-400 text-glow" data-id="element-22">DESDE EL PRIMER DÍA</span>
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-23">
          <div className="absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-24"></div>
          <img src="https://cdn.magicpatterns.com/uploads/28yrsyxoB7sEAXPvD5ECj1/mockup_final.png" alt="Punto Digital: kit completo para criar a tu cachorro, con seis tomos y bonos incluidos" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-25" />
        </div>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-26">
          Aprendé exactamente qué hacer desde el primer día para criar un
          cachorro tranquilo, obediente y feliz.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-27">
          <Badge className="whitespace-nowrap" data-id="element-28">✅ 100% Digital</Badge>
          <Badge className="whitespace-nowrap" data-id="element-29">⚡ Acceso inmediato</Badge>
          <Badge className="whitespace-nowrap" data-id="element-30">🐶 6 Tomos + 5 Bonos</Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-31">
          <Button size="md" className="w-full md:w-auto group" onClick={scrollToPurchase} data-id="element-32">
            <span className="group-hover:scale-110 transition-transform" data-id="element-33">
              🐾 SÍ, QUIERO EDUCAR BIEN A MI CACHORRO
            </span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-34" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-35">
            <span className="flex items-center" data-id="element-36">🛡️ Garantía 7 días</span>
            <span className="flex items-center" data-id="element-37">🔒 Pago seguro</span>
            <span className="flex items-center" data-id="element-38">⚡ Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}